import React from 'react';
import {
  Container,
  Paper,
  Title,
  Text,
  Button,
  Stack,
  Group,
  rem
} from '@mantine/core';
import { notifications } from '@mantine/notifications';
import {
  IconBrandGoogle,
  IconLock
} from '@tabler/icons-react';
import { useAuth } from '../utils/auth';

export default function ElderlyLogin() {
  const auth = useAuth();

  const handleGoogleLogin = () => {
    auth.signin((user) => {
      notifications.show({
        title: '驗證成功',
        message: `歡迎，${user.displayName}`,
        color: 'green',
      });
    });
  };

  return (
    <Container size="sm" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center' }}>
      <Paper
        shadow="xl"
        radius="lg"
        p="xl"
        style={{
          width: '100%',
          maxWidth: rem(500),
          margin: '0 auto',
          backgroundColor: '#fafafa'
        }}
      >
        <Stack gap="xl" align="center">
          <Group gap="md">
            <IconLock size={48} color="#495057" />
            <Title
              order={1}
              size="xl"
              style={{
                fontSize: rem(32),
                color: '#495057',
                textAlign: 'center'
              }}
            >
              安全登入
            </Title>
          </Group>

          <Text
            size="xl"
            style={{
              fontSize: rem(20),
              textAlign: 'center',
              color: '#495057',
              lineHeight: 1.6
            }}
          >
            請使用授權帳號登入
            <br />
            確保資料安全與隱私
          </Text>

          <Button
            variant="filled"
            color="gray"
            size="xl"
            leftSection={<IconBrandGoogle size={24} />}
            onClick={handleGoogleLogin}
            style={{
              width: '100%',
              height: rem(60),
              fontSize: rem(18),
              fontWeight: 600,
              marginTop: rem(20),
              backgroundColor: '#495057',
              '&:hover': {
                backgroundColor: '#343a40'
              }
            }}
          >
            登入系統
          </Button>

          <Text
            size="lg"
            style={{
              fontSize: rem(16),
              textAlign: 'center',
              color: '#868e96',
              lineHeight: 1.6
            }}
          >
            點擊上方按鈕進行身份驗證
            <br />
            使用您的 Google 帳號授權登入
          </Text>
        </Stack>
      </Paper>
    </Container>
  );
}
